<template>
    <!-- main section -->
        <section class="hero is-flex main">
            <div class="card">
                <div class="card-content">
                        <div class="img1 practice-bg"><img :src="require(`@/assets/images/cap.png`)" alt=""></div>
                        <div class="img2 practice-bg"><img :src="require(`@/assets/images/cross.png`)" alt=""></div>
                        <div class="img3 practice-bg"><img :src="require(`@/assets/images/clock.png`)" alt=""></div>
                        <div class="img4 practice-bg">
                            <div class="img4-inner">
                                <img class="pencil" :src="require(`@/assets/images/pencil.png`)" alt="">
                                <img :src="require(`@/assets/images/bird.png`)" alt="">
                            </div>
                            
                        </div>
                        <div class="img5 practice-bg"><img :src="require(`@/assets/images/stars.png`)" alt=""></div>
                        <div class="img6 practice-bg"><img :src="require(`@/assets/images/rainbow2.png`)" alt=""></div>
                        <div class="img7 practice-bg"><img :src="require(`@/assets/images/cloud4.png`)" alt=""></div>
                    <div class="tabs">
                        <ul>
                            <li class="active">
                                <a>
                                    <span>Practice</span>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>Analytic</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div id="tab-content">
                        <div class="practice-tab" id="practice">
                            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
        
                            <div class="card-container">
                                <div class="practice-card" v-for="classroom in fetchClassrooms" :key="classroom._id">
                                    <div class="card-title" 
                                    @click="$router.push({ name: 'classroom-details', params: { id:classroom._id } })"><b>{{ classroom.name}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </template>
  <script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'UserClassrooms',
    components: {
    },
    props : {
      kid_id : {
        type : String,
        required : true
      }
    },
    data() {
      return {
        isLoading: false,
      }
    },
    methods: {
      ...mapActions(['loadKids', 'loadClassrooms']),
    },
    computed: {
      ...mapGetters(['getUserType', 'getTeacherToken', 'fetchClassrooms', 'fetchKids', 'fetchColors']),
    },
    created() {
      this.isLoading = true
      this.loadKids({
        token: this.getTeacherToken
      })
      this.loadClassrooms({
        token: this.getTeacherToken,
      }).then(() => {
        this.isLoading = false
      })
    }
  
  
  } 
  </script>
  <style scoped>
  .flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .container {
    position: relative;
  }
  
  .bg-img {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .bg-img div {
    display: flex;
    position: absolute;
    width: auto;
  }
  
  .title {
    font-size: 3vw;
    margin: 0 !important;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  
  .button {
    flex-direction: row;
    padding: 1vw 1.25vw;
    width: 100%;
    background: #8919e7;
    border-radius: 1vw;
    color: #fff;
    gap: 1vw;
    cursor: pointer;
    position: relative;
    text-transform: capitalize;
  }
  .button.outline {
    border: 0.063rem solid #8919e7;
    background: #fff;
    color: #000;
  }
  .link {
    cursor: pointer;
  }
  .main {
    align-items: center;
    margin: 6.76vw 0vw;
    position: relative;
    gap: 2.4vw;
  }
  /* responsive page*/
  
  /* tablet */
  @media screen and (max-width: 1023px) {
    .title{
      font-size: 3.5vw !important;
    }
  }
  
  /* Mobiles */
  @media screen and (max-width: 767px) {
    .title {
      font-size: 4vw !important;
    }
  }
  
  @media screen and (max-width: 467px){
    .title{
      font-size: 5vw !important;
    }
  }
  .practice-bg {
    position: absolute;
    z-index: 10;
  }
  .practice-bg img {
    height: 150px;
    max-width: 100%;
    width: auto;
  }
  
  .img1 {
    top: 0;
    left: 0;
  }
  
  .img2 {
    top: -3%;
    left: 17%;
  }
  .img2 img {
    height: 85px;
  }
  
  .img3 {
    top: -9%;
    left: 43%;
    z-index: 0;
  }
  
  .img4 {
    right: 4%;
    top: -5%;
  }
  .img4 .img4-inner {
    position: relative;
  }
  .img4 .img4-inner .pencil {
    position: absolute;
    left: -12%;
  }
  
  .img5 {
    right: 13%;
    bottom: 22%;
  }
  .img5 img {
    height: auto;
  }
  
  .img6 {
    right: -5%;
    bottom: 0;
  }
  .img6 img {
    height: auto;
  }
  
  .img7 {
    bottom: 0;
    left: -2%;
    right: -2%;
  }
  
  .main .card {
    box-shadow: none;
  }
  .main .card .card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .main .card .card-content #tab-content {
    background: linear-gradient(75.66deg, rgba(138, 25, 231, 0.1) 9.81%, rgba(49, 200, 255, 0.1) 95.1%);
    border-radius: 30px 30px 0px 0px;
    width: 100%;
    padding: 59px 68px 115px;
  }
  .main .card .card-content #tab-content .card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
  }
  .main .card .card-content #tab-content .card-container .practice-card {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 15px;
    max-width: 312px;
    aspect-ratio: 312/217;
    flex: 1 1 312px;
  }
  .main .card .card-content #tab-content .card-container .practice-card:hover {
    background: linear-gradient(58.3deg, #8919e7 -26.52%, #31c7ff 104.77%);
    box-shadow: 5px 37px 27px -15px rgba(4, 45, 61, 0.13);
  }
  .main .card .card-content #tab-content .card-container .practice-card:hover .card-title,
  .main .card .card-content #tab-content .card-container .practice-card:hover .card-content {
    color: #fff;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-title {
    padding: 16px 30px;
    border-bottom: 1px solid #e1e1e1;
    text-transform: capitalize;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #232323;
  }
  .main .card .card-content #tab-content .card-container .practice-card .card-content {
    padding: 20px 30px;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #6d6d6d;
  }
  .main .card .card-content .tabs {
    width: 100%;
    width: 100%;
    justify-content: center;
    margin-bottom: 0;
    z-index: 1;
  }
  .main .card .card-content .tabs ul {
    border: 1px solid #8919e7;
    border-bottom: none;
    border-radius: 28.5px 28.5px 0px 0px;
    justify-content: center;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    flex-shrink: 1;
    max-width: 43.5%;
    background: #fff;
  }
  .main .card .card-content .tabs li.active {
    background: #8919e7;
    border-radius: 28.5px 28.5px 0px 0px;
  }
  .main .card .card-content .tabs li {
    all: unset;
    width: 100%;
    max-width: 50%;
  }
  .main .card .card-content .tabs li a {
    padding: 21px 0 17px;
  }
  
  @media screen and (max-width: 768px) {
    .main .card .card-content #tab-content {
      padding: 25px 20px;
    }
    .practice-bg {
      display: none;
    }
    .card-container {
      justify-content: center;
    }
    .main .card .card-content .tabs ul {
      max-width: 85%;
    }
    .main .card .card-content .tabs li a {
      padding: 10px 0 10px;
    }
  }
  .grade-card {
    padding: 12px 10px 12px 10px;
    border-radius: 5px;
  }
  
  .grade-heading {
    padding: 5px 50px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-left: -10px;
  }
  
  .grade-description {
    margin: 14px 0 12px 0;
  }
  
  .grade-subject-label {
    color: #000;
    padding-top: 12px;
  }
  </style>